import {
  ModalProps,
  createUseModal,
  useModal,
} from "@imminently/react/context/modals";
import { Dialog, DialogContent } from "@imminently/react/ui/core/dialog";
import { Text } from "@imminently/react/ui/core/text";
import { Box, Button, Stack } from "@mui/material";

import { HighriskIcon } from "@/assets/icons";
import { RISK_COLOURS, RISK_LABELS } from "@/resources/constants";
import { ClinicalRisk, NEWS2Score } from "@/resources/types";

const styles = {
  messageTitle: {
    justifyContent: "space-between",
    borderRadius: "0.6rem 0.6rem 0 0",
    pt: 1.4,
    pb: 0.8,
    px: 2.4,
  },
  messageBody: {
    borderRadius: "0 0 0.6rem 0.6rem",
    py: 1.4,
    px: 2.4,
  },
};

const PatientRiskModal = ({ props }: ModalProps<{ score: NEWS2Score }>) => {
  const { score } = props;
  const { popModal } = useModal();

  // Modal is not shown if Risk Score is low
  if (score.risk === ClinicalRisk.LOW) return null;

  const text = RISK_LABELS[score.risk];
  const colors = RISK_COLOURS[score.risk];

  const titleStyles = { ...styles.messageTitle, bgcolor: colors.main };
  const bodyStyles = { ...styles.messageBody, bgcolor: colors.light };

  return (
    <Dialog open>
      <DialogContent sx={{ p: 5 }}>
        <Stack display="flex" alignItems="center" gap={2}>
          <HighriskIcon />
          <Text variant="h4">Sepsis Risk</Text>
        </Stack>

        <Stack sx={{ maxWidth: 400, my: 3 }}>
          <Stack direction="row" sx={titleStyles}>
            <Text variant="h5">Risk</Text>
            <Text variant="h5">{text.title} - {score.score}</Text>
          </Stack>

          <Text sx={bodyStyles}>{text.description}</Text>
        </Stack>

        <Box display="flex" justifyContent="center">
          <Button size="large" onClick={popModal}>Acknowledge</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export const usePatientRiskModal = createUseModal(PatientRiskModal);
